import { Api } from 'modules/core';

export function generateAssetURL(assetType, assetClass, context) {
  const endpoint = 'assets/actions/generate-url';
  const item = {
    resourceType: 'asset-actions',
    assetType,
    assetClass,
    context,
  };

  return Api.create(endpoint, item); // POST request to Ahab server
}

export function signUploadURL(fileName, assetPath) {
  const endpoint = 'assets/actions/sign-upload';
  const item = {
    resourceType: 'asset-actions',
    fileName,
    assetPath,
  };

  return Api.create(endpoint, item); // POST request to Ahab server
}
// S3 file upload
export function uploadFileToServer(assetUploadPath, file) {
  return Api.upload(assetUploadPath, file); // PUT request
}

export function signDownloadURL(assetPath, headers) {
  if (!assetPath) {
    return Promise.reject('No image to get.');
  }

  const endpoint = 'assets/actions/sign-download';
  const item = {
    resourceType: 'asset-actions',
    assetPath,
  };

  return Api.create(endpoint, item, {}, {}, headers);
}

export function downloadAsset(currentAudioUrl, convertToUrl = true) {
  return fetch(currentAudioUrl)
    .then(response => {
      if (!response.ok || response.status !== 200) {
        return Promise.reject('Unable to download asset');
      }
      return response.blob();
    })
    .then(blob => {
      if (!convertToUrl) {
        return blob;
      }

      let url = '';
      const myURL = window.URL || window.webkitURL;

      try {
        url = myURL.createObjectURL(blob);
        // eslint-disable-next-line no-unused-vars
      } catch (err) {
        // Firefox
        url = myURL.createObjectURL(blob);
      }

      return url;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

export function signProducerApplicationUploadUrl(fileName, assetPath) {
  const endpoint = 'assets/actions/sign-producer-approval-clip-upload';
  const item = {
    resourceType: 'asset-actions',
    fileName,
    assetPath,
  };

  return Api.create(endpoint, item);
}
